"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractRouteStopQuery = exports.AbstractRouteStop = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../../common");
const enums_1 = require("../enums");
const CommercialSubscription_1 = require("../subscriptions-and-billing/CommercialSubscription");
const SubscriptionEquipment_1 = require("../subscriptions-and-billing/SubscriptionEquipment");
exports.AbstractRouteStop = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    customerID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    stopType: enums_1.StopType,
    serviceLocation: common_1.ServiceLocationTransport,
    subscriptionEquipment: typebox_1.Type.Optional(SubscriptionEquipment_1.SubscriptionEquipmentTransport),
    ordinal: typebox_1.Type.Integer({ minimum: 0 }),
    latitude: typebox_1.Type.Number(),
    longitude: typebox_1.Type.Number(),
    // Commercial Subscription Fields
    timeRestriction: typebox_1.Type.Optional(CommercialSubscription_1.CommercialSubscriptionTimeRestriction),
    gateCode: typebox_1.Type.Optional(typebox_1.Type.String()),
    notes: typebox_1.Type.Optional(typebox_1.Type.String()),
    metadata: common_1.MetaData,
});
exports.AbstractRouteStopQuery = typebox_1.Type.Object({
    // This should only ever be used in a Type.Intersect call, wrapped by Type.Partial. It's not a standalone type.
    customerID: typebox_1.Type.String({ format: 'uuid' }),
    hasOneOffPickupRequest: typebox_1.Type.Boolean(),
    oneOffPickupRequestID: typebox_1.Type.String({ format: 'uuid' }),
    stopType: enums_1.StopType,
    serviceLocation: common_1.ServiceLocationTransport,
    subscriptionEquipmentID: typebox_1.Type.String({ format: 'uuid' }),
    subscriptionID: typebox_1.Type.String({ format: 'uuid' }),
    latitudeAbove: typebox_1.Type.Number(),
    latitudeBelow: typebox_1.Type.Number(),
    longitudeAbove: typebox_1.Type.Number(),
    longitudeBelow: typebox_1.Type.Number(),
});
//# sourceMappingURL=AbstractRouteStop.js.map